import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-dashboard',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminDashboardComponent implements OnInit {
    public metrics: any = {};
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("metrics");
        if (code === 200) {
            this.metrics = data;
        }
        this.loading = false;
        await this.service.render();
    }
}

export default PortalNrichadminAdminDashboardComponent;